import PropTypes from 'prop-types';

import { useEffect } from 'react';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';
import Tracking from '@spotahome/soyuz-tracking';

import { CitiesProvider } from '../../context/CitiesContext';

import Hero from './Hero/Hero';
import FindPlace from './FindPlace';
import RelevantLinkSection from './RelevantLinkSection';
import CityListContainer from './CityListContainer/CityListContainer';

const GenericErrorContent = ({ title = 'error_page.client_error.title' }) => {
  useEffect(() => {
    Tracking.hotjar.triggerEvent('GenericErrorContent');
    SoyuzAnalytics.sendGA4Event('send', {
      section: 'generic-error-content',
      action: 'view'
    });
  }, []);
  return (
    <CitiesProvider>
      <Hero title={title} />
      <FindPlace />
      <RelevantLinkSection />
      <CityListContainer />
    </CitiesProvider>
  );
};

GenericErrorContent.propTypes = {
  title: PropTypes.string
};

export default GenericErrorContent;
